import './App.css';

function App() {
  return (
    <div className="App">
      <div className="App-header">
        <div id="content-wrap">
          <p style={{fontSize:"40pt"}}>
            私人宅院&emsp;禁止通行
          </p>
        </div>
        <footer id="footer">
        © 2009-2023 engful.com 版权所有 <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer" style={{color:"#aaaaaa"}}>津ICP备2023005532号-1</a>
        </footer>
      </div>
    </div>
  );
}

export default App;
